import { images, diplomasBg } from "utils/images"
import { masterBreakPoint } from "themes/default/breakpoints"

export const styles = (textSize) => {
  return {
    content: {
      flexShrink: 0,
      background: "white",
      position: "relative",
      overflow: "hidden",
      /* width: 1056px; */
      /* height: 816px; */
      "&:before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: `url(${images.diplomaFrame})`,
        backgroundSize: "100% 100%",
        zIndex: 10,
      },
    },
    secondaryContent: {
      p: 8.75,
      "&:before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundImage: `url(${images.diplomaFrame2})`,
        backgroundSize: "100% 100%",
        zIndex: 10,
      },
    },
    diplomaSmash: {
      width: "35%",
      flexShrink: 0,
      flexWrap: "nowrap",
      alignContent: "center",
      alignItems: "center",
      height: "100%",
      justifyContent: "space-evenly",
      backgroundColor: "#fffdf6",
      backgroundImage: `url(${diplomasBg[1]})`,
      backgroundSize: "100% 100%",
    },
    diplomaDetails: {
      flex: 1,
      flexWrap: "nowrap",
      alignContent: "center",
      alignItems: "center",
      height: "100%",
      justifyContent: "space-between",
      backgroundColor: "#fdf6e6",
      py: 6.25,
      // px: 1.25,
      // pr: 2.5,
      // py: 3.25,
    },
    smashFooter: {
      fontStyle: "italic",
      fontSize: textSize * 0.16,
      fontFamily: "Georgia Regular",
      px: 3.75,
      py: 0,
      textAlign: "center",
      lineHeight: "1",
      [masterBreakPoint]: {
        fontSize: textSize * 0.16,
      },
    },
    section: {
      width: "80%",
    },
    title: {
      textAlign: "center",
      fontSize: textSize,
      fontFamily: '"Times New Roman", Times, serif',
      color: "#0f2d39",
      textShadow: "0 1px 0 #f99401,0 2px 0 #f99401,0 3px 0 #f99401",
      lineHeight: "1",
      [masterBreakPoint]: {
        fontSize: textSize,
      },
    },
    title2: {
      textAlign: "center",
      fontFamily: "Playfair Display",
      fontWeight: 600,
      fontStyle: "italic",
      color: "#f99401",
      fontSize: textSize * 0.25,
      lineHeight: "1",
      [masterBreakPoint]: {
        fontSize: textSize * 0.25,
      },
    },
    user: {
      textAlign: "center",
      fontSize: textSize * 0.7,
      position: "relative",
      fontFamily: "Playfair Display",
      padding: 0,
      margin: 0,
      lineHeight: "1",
      wordBreak: "break-word",
      [masterBreakPoint]: {
        fontSize: textSize * 0.7,
      },
    },
    userLine: {
      position: "relative",
      width: "100%",
      height: 3,
      background: "#f4c34e",
      marginTop: 2.5,
      "&:before": {
        content: '""',
        width: 10,
        height: 10,
        background: "#f4c34e",
        position: "absolute",
        left: 0,
        bottom: "-3px",
        borderRadius: "50%",
      },
      "&:after": {
        content: '""',
        width: 10,
        height: 10,
        background: "#f4c34e",
        position: "absolute",
        right: 0,
        bottom: "-3px",
        borderRadius: "50%",
      },
    },
    reason: {
      px: 3.75,
      py: 1.875,
      fontStyle: "italic",
      fontFamily: "Georgia Regular",
      fontSize: textSize * 0.16,
      textAlign: "center",
      lineHeight: "1",
      fontWeight: 100,
      [masterBreakPoint]: {
        fontSize: textSize * 0.16,
      },
    },
    diplomaSignature: {},
    signatureTitle: {
      borderBottom: `3px solid #f4c34e`,
      px: 1.875,
      py: 0.625,
      fontWeight: "bold",
      fontFamily: "Playfair Display",
      fontSize: textSize * 0.16,
      textTransform: "capitalize",
      width: 150,
      height: 50,
      textAlign: "center",
      justifyContent: "center",
      alignItems: "flex-end",
      display: "flex",
      lineHeight: "1",
      [masterBreakPoint]: {
        fontSize: textSize * 0.16,
      },
    },
    signatureLabel: {
      textAlign: "center",
      fontWeight: "bold",
      fontFamily: "Playfair Display",
      pt: 0.625,
      fontSize: textSize * 0.16,
      textTransform: "capitalize",
      [masterBreakPoint]: {
        fontSize: textSize * 0.16,
      },
    },
    signatureSeal: {
      width: 140,
      height: "auto",
      display: "block",
    },
    signatureSection: {
      display: "block",
    },
    diplomaDedication: {
      textAlign: "center",
      fontStyle: "italic",
      lineHeight: "1",
      fontFamily: "Georgia Regular",
      fontSize: textSize * 0.16,
      [masterBreakPoint]: {
        fontSize: textSize * 0.16,
      },
    },
    titleImg: {
      display: "block",
      maxWidth: "100%",
      height: "auto",
    },
    diplomaDetails2: {
      background: "none",
      maxWidth: "60%",
      mr: "auto",
      flexShrink: 1,
      py: 2.5,
      px: 0,
    },
    diplomaSmash2: {
      width: "20%",
      background: "none",
      justifyContent: "flex-end",
      pb: 2.5,
    },
    section2: {
      width: "100%",
    },
    title21: {
      color: "#29395d",
      fontStyle: "normal",
      fontSize: textSize * 0.22,
      fontWeight: "normal",
    },
    user2: {
      fontFamily: "'Great Vibes', cursive",
      color: "#29395d",
    },
    userLine2: {
      mt: 3.75,
      "&:before": {
        content: '""',
        width: 16,
        height: 16,
        background: "#f4c34e",
        position: "absolute",
        left: 0,
        bottom: "-6px",
        borderRadius: "50%",
      },
      "&:after": {
        content: '""',
        width: 16,
        height: 16,
        background: "#f4c34e",
        position: "absolute",
        right: 0,
        bottom: "-6px",
        borderRadius: "50%",
      },
    },
    lineSpan: {
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      "&:before": {
        content: '""',
        width: 15,
        height: 10,
        background: "#f4c34e",
        position: "absolute",
        left: "initial",
        bottom: "-3px",
        right: "-15px",
        borderRadius: "50%",
      },
      "&:after": {
        content: '""',
        width: 15,
        height: 10,
        background: "#f4c34e",
        position: "absolute",
        bottom: "-3px",
        left: "-15px",
        borderRadius: "50%",
      },
    },
    encouragement: {
      py: 1.25,
      fontWeight: "bold",
      color: "#092834",
      fontSize: textSize * 0.16,
      fontFamily: "Playfair Display",
      textAlign: "center",
      lineHeight: "1",
    },
    reason2: {
      p: "5px 0",
      fontStyle: "initial",
      color: "#092834",
      fontFamily: "Playfair Display",
      lineHeight: "1",
    },
    signatureSection2: {
      justifyContent: "space-around",
    },
    signatureTitle2: {
      borderBottom: `3px dotted #f4c34e`,
    },
    signatureLabel2: {
      fontFamily: "Georgia Italic",
      textTransform: "uppercase",
    },
    diplomaDedication2: {
      fontStyle: "initial",
      color: "#092834",
      fontFamily: "Playfair Display",
    },
  }
}
